// Hand-written (Pull 4): reui.io/r/{style}/spinner.json returns 401 (Pro-gated item);
// the data-grid family only needs a minimal spinning glyph.
import { LoaderCircleIcon } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/cn';

const Spinner = React.forwardRef<SVGSVGElement, React.ComponentPropsWithoutRef<'svg'>>(
  ({ className, ...props }, ref) => (
    <LoaderCircleIcon
      ref={ref}
      aria-hidden="true"
      data-slot="spinner"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  )
);
Spinner.displayName = 'Spinner';

export { Spinner };
